var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16,
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1152,
    height: 700,
    transform: "translate(-24 -91)",
    fill: "#F9FBFD"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -24,
    y: -91,
    width: 220,
    height: 700,
    fill: "var(--svgaccordionbackgroundcolor)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_5_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.632199 0C0.283045 0 0 0.283045 0 0.632199C0 0.981353 0.283045 1.2644 0.632199 1.2644H6.05105C6.4002 1.2644 6.68325 0.981353 6.68325 0.632199C6.68325 0.283045 6.4002 0 6.05105 0H0.632199Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98691 2.63874C1.63776 2.63874 1.35471 2.92179 1.35471 3.27094C1.35471 3.6201 1.63776 3.90314 1.98691 3.90314H6.09725C6.4464 3.90314 6.72945 3.6201 6.72945 3.27094C6.72945 2.92179 6.4464 2.63874 6.09725 2.63874H1.98691Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34162 5.60733C2.99247 5.60733 2.70942 5.89037 2.70942 6.23953C2.70942 6.58868 2.99247 6.87173 3.34162 6.87173H6.08645C6.4356 6.87173 6.71865 6.58868 6.71865 6.23953C6.71865 5.89037 6.4356 5.60733 6.08645 5.60733H3.34162Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.03501 8.24607C4.68586 8.24607 4.40281 8.52912 4.40281 8.87827C4.40281 9.22743 4.68586 9.51047 5.03501 9.51047H6.08645C6.4356 9.51047 6.71865 9.22743 6.71865 8.87827C6.71865 8.52912 6.4356 8.24607 6.08645 8.24607H5.03501Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6826 1.8966H7.58639V13.4411H9.27978C9.61845 15.0903 10.945 15.75 12.1698 15.75C13.3946 15.75 14.7212 14.8017 15.0373 13.4411H19.4401V6.5144L15.0373 4.86518L13.6826 1.8966ZM9.64103 3.73822H12.1698L13.3439 6.18455H9.64103V3.73822ZM12.1698 11.3246C12.1698 11.3246 13.3439 11.2696 13.3439 12.589C13.3439 13.8638 12.4164 13.8555 12.1908 13.8535C12.183 13.8535 12.1759 13.8534 12.1698 13.8534C12.1638 13.8534 12.1568 13.8535 12.1488 13.8535C11.9181 13.8555 10.9054 13.8644 10.9054 12.589C10.9054 11.2696 12.1698 11.3246 12.1698 11.3246Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.632199 0C0.283045 0 0 0.283045 0 0.632199C0 0.981353 0.283045 1.2644 0.632199 1.2644H6.05105C6.4002 1.2644 6.68325 0.981353 6.68325 0.632199C6.68325 0.283045 6.4002 0 6.05105 0H0.632199Z",
    fill: "var(--svgaccordioncolor)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98691 2.63874C1.63776 2.63874 1.35471 2.92179 1.35471 3.27094C1.35471 3.6201 1.63776 3.90314 1.98691 3.90314H6.09725C6.4464 3.90314 6.72945 3.6201 6.72945 3.27094C6.72945 2.92179 6.4464 2.63874 6.09725 2.63874H1.98691Z",
    fill: "var(--svgaccordioncolor)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34162 5.60733C2.99247 5.60733 2.70942 5.89037 2.70942 6.23953C2.70942 6.58868 2.99247 6.87173 3.34162 6.87173H6.08645C6.4356 6.87173 6.71865 6.58868 6.71865 6.23953C6.71865 5.89037 6.4356 5.60733 6.08645 5.60733H3.34162Z",
    fill: "var(--svgaccordioncolor)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.03501 8.24607C4.68586 8.24607 4.40281 8.52912 4.40281 8.87827C4.40281 9.22743 4.68586 9.51047 5.03501 9.51047H6.08645C6.4356 9.51047 6.71865 9.22743 6.71865 8.87827C6.71865 8.52912 6.4356 8.24607 6.08645 8.24607H5.03501Z",
    fill: "var(--svgaccordioncolor)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6826 1.8966H7.58639V13.4411H9.27978C9.61845 15.0903 10.945 15.75 12.1698 15.75C13.3946 15.75 14.7212 14.8017 15.0373 13.4411H19.4401V6.5144L15.0373 4.86518L13.6826 1.8966ZM9.64103 3.73822H12.1698L13.3439 6.18455H9.64103V3.73822ZM12.1698 11.3246C12.1698 11.3246 13.3439 11.2696 13.3439 12.589C13.3439 13.8638 12.4164 13.8555 12.1908 13.8535C12.183 13.8535 12.1759 13.8534 12.1698 13.8534C12.1638 13.8534 12.1568 13.8535 12.1488 13.8535C11.9181 13.8555 10.9054 13.8644 10.9054 12.589C10.9054 11.2696 12.1698 11.3246 12.1698 11.3246Z",
    fill: "var(--svgaccordioncolor)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.632199 0C0.283045 0 0 0.283045 0 0.632199C0 0.981353 0.283045 1.2644 0.632199 1.2644H6.05105C6.4002 1.2644 6.68325 0.981353 6.68325 0.632199C6.68325 0.283045 6.4002 0 6.05105 0H0.632199Z",
    stroke: "var(--svgaccordioncolor)",
    strokeWidth: 4,
    strokeLinejoin: "round",
    mask: "url(#path-2-inside-1_5_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98691 2.63874C1.63776 2.63874 1.35471 2.92179 1.35471 3.27094C1.35471 3.6201 1.63776 3.90314 1.98691 3.90314H6.09725C6.4464 3.90314 6.72945 3.6201 6.72945 3.27094C6.72945 2.92179 6.4464 2.63874 6.09725 2.63874H1.98691Z",
    stroke: "var(--svgaccordioncolor)",
    strokeWidth: 4,
    strokeLinejoin: "round",
    mask: "url(#path-2-inside-1_5_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34162 5.60733C2.99247 5.60733 2.70942 5.89037 2.70942 6.23953C2.70942 6.58868 2.99247 6.87173 3.34162 6.87173H6.08645C6.4356 6.87173 6.71865 6.58868 6.71865 6.23953C6.71865 5.89037 6.4356 5.60733 6.08645 5.60733H3.34162Z",
    stroke: "var(--svgaccordioncolor)",
    strokeWidth: 4,
    strokeLinejoin: "round",
    mask: "url(#path-2-inside-1_5_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.03501 8.24607C4.68586 8.24607 4.40281 8.52912 4.40281 8.87827C4.40281 9.22743 4.68586 9.51047 5.03501 9.51047H6.08645C6.4356 9.51047 6.71865 9.22743 6.71865 8.87827C6.71865 8.52912 6.4356 8.24607 6.08645 8.24607H5.03501Z",
    stroke: "var(--svgaccordioncolor)",
    strokeWidth: 4,
    strokeLinejoin: "round",
    mask: "url(#path-2-inside-1_5_2)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6826 1.8966H7.58639V13.4411H9.27978C9.61845 15.0903 10.945 15.75 12.1698 15.75C13.3946 15.75 14.7212 14.8017 15.0373 13.4411H19.4401V6.5144L15.0373 4.86518L13.6826 1.8966ZM9.64103 3.73822H12.1698L13.3439 6.18455H9.64103V3.73822ZM12.1698 11.3246C12.1698 11.3246 13.3439 11.2696 13.3439 12.589C13.3439 13.8638 12.4164 13.8555 12.1908 13.8535C12.183 13.8535 12.1759 13.8534 12.1698 13.8534C12.1638 13.8534 12.1568 13.8535 12.1488 13.8535C11.9181 13.8555 10.9054 13.8644 10.9054 12.589C10.9054 11.2696 12.1698 11.3246 12.1698 11.3246Z",
    stroke: "var(--svgaccordioncolor)",
    strokeWidth: 4,
    strokeLinejoin: "round",
    mask: "url(#path-2-inside-1_5_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5_2",
    x: -39,
    y: -104,
    width: 250,
    height: 730,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1152,
    height: 700,
    fill: "white",
    transform: "translate(-24 -91)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJob);
export default __webpack_public_path__ + "static/media/Job.8c3922a92cc19691e92d41d6dc280c3d.svg";
export { ForwardRef as ReactComponent };